const { Col, Row } = require("react-bootstrap");
import { Container, Form } from "reactstrap";
import styled from "styled-components/macro";

export const WrapperLeft = styled(Col)`
`
export const WrapperConnector = styled.div`
    padding:1rem;
    border-top: 1px solid  #F0F0F0;

 `
 export const WrapperRowError=styled.div`
     display: flex;
    align-items: flex-start;
    border: 1px solid #FFD2D2;
    background: #FFEDED;
    padding:4px 8px;
    border-radius:4px;
    gap:8px;
    width:fit-content;
 `
export const WrapperError = styled.div`
    display: flex;
    align-items: flex-start;
    border: 1px solid #FFD2D2;
    background: #FFEDED;
    padding:4px 8px;
    border-radius:4px;
    gap:8px;

 `
export const WrapperDiv = styled.div`
	display: flex;
	justify-content: space-between;
	padding:24px 16px;
	/* border-bottom: 1px solid  #F0F0F0; */
`;
export const WrapperRight = styled(Col)`
display:flex;
justify-content:flex-end;
`
export const ImgWrapper = styled.img`
	height: 40px;
`;

export const ContainerPage=styled(Container)`
	display: flex;
	flex-direction: column;
`

export const WrapperHeader = styled.div`
    display:flex;
     align-items:center; 
     justify-content:center;
    background:#FAFAFA;
    border-bottom: 1px solid #EFEFEF;
    width:100%;
    border-top-left-radius: 4px;
    border-top-right-radius:4px;
`
export const WrapperPage = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    align-self:center;
    width:552px;
    border: 1px solid #EFEFEF;
    border-radius:4px;
    margin-top:3rem;


`
export const WrapperFooter = styled.div`
    display:flex;
     justify-content:end;

`
export const WrapperForm = styled(Form)`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    width:552px;
`

export const WrapperSearch = styled.div`
width:262px;

`

export const WrapperHerf=styled.a`
	font-size: ${(props) => props.size}px;
    text-decoration:none;
    color:#262626;

&:hover{
    text-decoration:underline;
    color:#262626;
    cursor: pointer;
}
`
export const WrapperBorderDiv = styled.div`
width:100%;
border-bottom:1px solid #F0F0F0;
padding-top:1rem;
padding-bottom:1rem;
`
export const WrapperColHerf=styled(Col)`
align-self:center;
`

export const WrapperBox=styled.div`
border-radius: 4px;
border: 1px solid  #D9D9D9;
`